<template>
	<bernstein-layout>
		<!-- Hello {{ name }} welcome to my app. -->
		<!-- {{getName()}} -->
		<!-- {{getName()}} -->
		<!-- <hr /> -->
		<!-- <counter></counter> -->
		<!-- Header starts here  -->
		<div class="flex flex-row justify-between py-2">
			<Link
				v-if="orders.prev_page_url"
				class="m-2 rounded bg-gray-300 px-2 py-2"
				:href="orders.prev_page_url"
				>Previous Page
			</Link>
			<Link
				v-if="orders.next_page_url"
				class="m-2 rounded bg-gray-300 px-2 py-2"
				:href="orders.next_page_url"
				>Next Page
			</Link>
		</div>
		<!-- header ends  -->
		<!-- Table head starts  -->
		<Table
			:filters="queryBuilderProps.filters"
			:search="queryBuilderProps.search"
			:columns="queryBuilderProps.columns"
			:on-update="setQueryBuilder"
			:meta="orders"
			class="relative w-full border"
		>
			<!-- Table head  -->
			<template #head>
				<tr
					class="sticky border-b border-gray-400 bg-gray-300 py-2 font-bold text-gray-900"
				>
					<!-- <th @click.prevent="sortBy('name')">Stock Id</th> -->
					<!-- <td v-show="showColumn('manufacturerId')">S.N.</td> -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('orderId')"
						@click.prevent="sortBy('orderId')"
					>
						Order Id
					</th>
					<!-- externalId -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('externalId')"
						@click.prevent="sortBy('externalId')"
					>
						External Id
					</th>

					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('createdAt')"
						@click.prevent="sortBy('createdAt')"
					>
						Created At
					</th>
					<!-- Status name   -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('statusName')"
						@click.prevent="sortBy('statusName')"
					>
						Status Name
					</th>
					<!-- billNo -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('billNo')"
						@click.prevent="sortBy('billNo')"
					>
						Bill No
					</th>

					<!-- paymentType -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('paymentType')"
						@click.prevent="sortBy('paymentType')"
					>
						Payment Type
					</th>
					<!-- grossTotal -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('grossTotal')"
						@click.prevent="sortBy('grossTotal')"
					>
						Gross Total
					</th>
					<!-- deleveryCountry -->
					<th
						class="sticky top-0 border-r border-green-200"
						v-show="showColumn('deleveryCountry')"
						@click.prevent="sortBy('deleveryCountry')"
					>
						Delevery Country
					</th>
				</tr>
				<!-- <tr><th class="fixed top-0"> test</th> </tr>      -->
			</template>
			<!--
       ******
       * 
       * here starts the table body  
       *
       -->
			<template #body>
				<tr
					v-for="(order, orderIndx) in orders.data"
					:key="orderIndx"
					:class="[{ 'bg-gray-100': orderIndx % 2 == 0 }, p - 1]"
				>
					<td class="border-r border-green-200" v-show="showColumn('orderId')">
						{{ order.orderId }}
					</td>
					<!-- externalId -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('externalId')"
					>
						{{ order.externalId }}
					</td>

					<td
						class="border-r border-green-200"
						v-show="showColumn('createdAt')"
					>
						{{ order.createdAt }}
					</td>
					<!-- status name  -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('statusName')"
					>
						{{ order.statusName }}
					</td>
					<!-- billNo  -->
					<td class="border-r border-green-200" v-show="showColumn('billNo')">
						{{ order.billNo }}
					</td>

					<!-- paymentType -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('paymentType')"
					>
						{{ order.paymentType }}
					</td>
					<!-- grossTotal -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('grossTotal')"
					>
						{{ order.grossTotal }}
					</td>
					<!-- deleveryCountry -->
					<td
						class="border-r border-green-200"
						v-show="showColumn('deleveryCountry')"
					>
						{{ order.deleveryCountry }}
					</td>
				</tr>
			</template>
			<!-- Table head ends here  -->
		</Table>
	</bernstein-layout>
</template>
<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import BernsteinLayout from "@/Layouts/BernsteinLayout.vue";
import {
	InteractsWithQueryBuilder,
	Tailwind2,
} from "@protonemedia/inertiajs-tables-laravel-query-builder";
import {
	TransitionRoot,
	TransitionChild,
	Dialog,
	DialogOverlay,
	DialogTitle,
} from "@headlessui/vue";
import { defineComponent, ref } from "vue";
// import Counter from "./Counter.vue";
export default defineComponent({
	mixins: [InteractsWithQueryBuilder],
	components: {
		BernsteinLayout,
		Head,
		Link,
		Table: Tailwind2.Table,
		// Modal components
		TransitionRoot,
		TransitionChild,
		Dialog,
		DialogOverlay,
		DialogTitle,
	},
	props: {
		orders: Array,
	},
	setup() {
		name = ref("test");
		// const name = ref<string>("Bijaya");
		return {
			name,
			getName() {
				console.log("test");
			},
		};
	},
});
</script>
